<template>
  <div class="sides-class">
    <a :href="singleAdv.redirect" target="_blank" v-for="singleAdv in ListAdv" :key="singleAdv.id">
      <img class="ListAdv-img" :src="singleAdv.img" alt />
      <div class="icon">广告</div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    ListAdv: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.sides-class {
  max-height: 432px;
  overflow: hidden;
  margin-top: 5px;
}

a {
  position: relative;
}

.ListAdv-img {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  margin-top: 16px;
}

.icon {
  position: absolute;
  bottom: 8px;
  right: 4px;
  z-index: 1;
  width: 44px;
  height: 26px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.45);
  line-height: 26px;
  text-align: center;
}
</style>
